import { render, staticRenderFns } from "./DeleteRedaction.vue?vue&type=template&id=21ccfb0b&"
import script from "./DeleteRedaction.vue?vue&type=script&lang=js&"
export * from "./DeleteRedaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports